import {isEmpty} from "lodash-es";

export const selectIncidentsOverviewLoading = (state) =>
  state.incidentOverview.loading;
export const selectRelatedIncidentsCount = (state) =>
  state.incidentOverview.linkedReferences.incidentsCount;
export const selectRelatedIncidents = (state) =>
  state.incidentOverview.linkedIncidents;
export const selectAssetsData = (state) => state.incidentOverview.assets.data;
export const selectTopNAssetsData = (n) => (state) =>
  state.incidentOverview.assets.data.slice(0, n);
export const selectAssetsCount = (state) =>
  state.incidentOverview.assets.totalCount;
export const selectObservablesData = (state) =>
  state.incidentOverview.observables.data;
export const selectTopNObservablesData = (n) => (state) =>
  state.incidentOverview.observables.data.slice(0, n);
export const selectObservablesCount = (state) =>
  state.incidentOverview.observables.totalCount;
export const selectIndicatorsData = (state) =>
  state.incidentOverview.indicators.data;
export const selectTopNIndicatorsData = (n) => (state) =>
  state.incidentOverview.indicators.data.slice(0, n);
export const selectIndicatorsCount = (state) =>
  state.incidentOverview.indicators.totalCount;
export const selectIncidentInvestigationId = (state) =>
  state.incidentOverview.primaryInvestigation.id;
export const selectEntitiesByType = (state) =>
  state.incidentOverview.entitiesByType;
export const selectEntitiesByTypeLoading = (state) =>
  state.incidentOverview.loadingEntitiesByType;
export const selectAttackGraphItems = (state) => state.incidentOverview.items;
export const selectAttackGraphGroups = (state) => state.incidentOverview.groups;
export const selectAttackGraphInitialized = (state) =>
  state.incidentOverview.graphInitialized;
export const selectHasAttackGraphItems = (state) =>
  !isEmpty(state.incidentOverview.items);
